import {
  Activity,
  Home,
  LineChart,
  MapPin,
  Package,
  Store,
  Wallet,
} from 'lucide-react';

interface MenuLink {
  path: string;
  label: string;
  Icon: React.ElementType;
  children?: { path: string; label: string }[];
}

/**
 * Primary navigation entries for the Console shell.
 * New sections are added here as their milestones land.
 */
export const MENU_LINKS: MenuLink[] = [
  {
    path: '/',
    label: 'Inicio',
    Icon: Home,
  },
  {
    path: '/dispatch-places',
    label: 'Puntos 99',
    Icon: MapPin,
  },
  {
    path: '/orders',
    label: 'Órdenes',
    Icon: Package,
  },
  {
    path: '/finances',
    label: 'Finanzas',
    Icon: Wallet,
  },
  {
    path: '/analytics',
    label: 'Analíticas',
    Icon: LineChart,
  },
  {
    path: '/amazon',
    label: 'Amazon',
    Icon: Store,
  },
  {
    path: '/monitoring',
    label: 'Monitoreo',
    Icon: Activity,
  },
];
